export default __webpack_public_path__ + "static/media/googleplay.56ea7903.webp";